<template>
    <el-avatar class="u-avatar" :size="size" :src="srcUrl"></el-avatar>
</template>

<script>
import {avatarUrl, getThumbnail} from "@/utils";
export default {
    name: "Avatar",
    props: {
        src: {
            type: String,
            default: "",
        },
        size: {
            type: Number,
            default: 25,
        },
    },
    computed: {
        srcUrl() {
            let src = "";
            let avatar = this.src || "";
            if (!avatar) {
                return avatarUrl();
            }
            if (avatar.startsWith("http") || avatar.startsWith("//")) {
                src = avatar;
            } else if (avatar.startsWith("/")) {
                src = getThumbnail(('/' + avatar), this.size);
            }
            return getThumbnail(('/' + avatar), this.size);
        },
    },
};
</script>

<style lang="less"></style>
